import customworkspace1 from "../../../../assets/images/docs/customworkspace1.png";
import customworkspace2 from "../../../../assets/images/docs/customworkspace2.png";
import * as React from 'react';
export default {
  customworkspace1,
  customworkspace2,
  React
};